<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Publisher Group' },
    ]" title="All Publisher Groups" />
    <div class="bg-white w-full rounded-lg my-0 px-0 pt-3 pb-3 h-auto mb-5">
      <div class="flex justify-between py-3 px-4">
        <div class="relative">
          <svg class="w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3" aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
              d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
          </svg>
          <input class="bg-white rounded-lg py-2 px-11 border w-96" placeholder='Search Publisher Group Name'
            v-model="search" @input="onSearch" />
          <button v-if="search"
            class="absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            @click="actionReset" title="Clear search">
            ✕
          </button>

        </div>
        <button
          class="text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
          type="button">
          <router-link class="text-white px-1 py-2" :to="{ path: '/publisher-group-create' }">
            <i class="fa fa-plus"></i> Add New
          </router-link>
        </button>
      </div>
      <Table class="custom-table-parent" :headers="headers" :data="items || []"
        :row-key="['name', 'id', 'created', 'modified']" :current-page="currentPage" :isLoading="isLoading"
        :per-page="15">
        <template #header-joinDate="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                </svg>
              </span>
            </button>
          </div>
        </template>
        <template #header-modified="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                </svg>
              </span>
            </button>
          </div>
        </template>

        <template #created="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #id="{ row }">

          <span class="text-sm text-blue-700 underline font-medium" @click="showModal(row.id)">View Publishers</span>
        </template>
        <template #modified="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <!-- slot actions -->

        <template #actions="{ row }">
          <t-dropdown>
            <div slot="trigger" slot-scope="{
                mousedownHandler,
                focusHandler,
                blurHandler,
                keydownHandler,
                isShown
              }" class=" relative">
              <button id="user-menu" :class="{ ' text-gray-500 ': isShown }" aria-label="User menu" aria-haspopup="true"
                @focus.stop="focusHandler" @blur.stop="blurHandler" @keydown.stop="keydownHandler"
                @click.stop="mousedownHandler" class="cursor-pointer focus:outline-none">
                <svg class="w-6 h-6 text-gray-700 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                    d="M6 12h.01m6 0h.01m5.99 0h.01" />
                </svg>
              </button>
            </div>
            <div slot-scope="{ hide, blurHandler }">
              <button
                class="block text-left w-full px-3 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">

                <router-link :to="{ path: 'publisher-group/edit/' + row.id }"
                  class="link text-gray-600 align-middle items-center flex justify-start">
                  <svg class="w-6 h-6 text-gray-500 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd"
                      d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                      clip-rule="evenodd" />
                    <path fill-rule="evenodd"
                      d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                      clip-rule="evenodd" />
                  </svg>
                  <span class="ml-2 text-sm">
                    Edit
                  </span>
                </router-link>
              </button>
              <button
                class=" text-left w-full flex justify-start items-center px-3 py-2 text-sm  leading-5 text-gray-500 transition duration-150 ease-in-out hover:no-underline hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @click="showPopup(row.id)" @blur="blurHandler">
                <svg class="w-6 h-6 text-red-600 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                    clip-rule="evenodd" />
                </svg>

                <span class="ml-1.5 text-sm text-red-600">
                  Delete
                </span>
              </button>
            </div>
          </t-dropdown>
        </template>
      </Table>
      <div class="flex justify-between w-full ml-1 px-3 items-start mt-3">
        <div class="flex justify-between ml-1 px-3 w-full items-start mt-3">
          <div class="font-semibold mt-1">
            <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
              class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
          </div>
          <div class="mb-2">
            <t-pagination @change="handlePageClicklist" :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
              class="rounded-lg" />
          </div>
        </div>

      </div>
    </div>
      <t-modal ref="modalActionDelete">
      <div class="text-sm flex-col justify-start items-start text-left">
        <p class="text-base text-center font-semibold text-gray-900 mb-2">Do want to continue?</p>
        <div class="text-center">
           <p class="m-0">Are you sure want to delete this publisher group?</p>
           <p class="m-0">Please recheck before continuing.</p>
       
        </div>
        <div class="flex justify-center items-center mb-2 mt-3 space-x-3">
          <button @click="onDeletePublisher()" class="bg-red-700 rounded-xl px-2 py-1.5 text-white">Delete</button>
          <button @click="onCancel" class="border px-2 py-1.5 rounded-xl">Cancel</button>
        </div>

      </div>
    </t-modal>
    <t-modal-table ref="showtabel">
      <div class="flex-col w-auto custom-table py-3 px-3">
        <div class="flex justify-between items-center mb-3">
          <label class="text-gray-900 font-bold text-xl p-0">Publishers</label>
          <label class="cursor-pointer" @click="closeX">
            <svg class="w-6 h-6 text-gray-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>

          </label>
        </div>
        <div class="flex-col justify-center overflow-hidden border-l border-r border-t border-b rounded-xl">
          <Table :headers="headersDetailId" :data="fetchPublisherID || []"
            :row-key="['name', 'is_active', 'created', 'modified']" :current-page="currentPageDetailPublisher"
            :isLoading="isLoading" :withAction=false :per-page="10">
            <template #header-joinDate-detail="{ column }">
              <div class="flex items-center gap-1">
                {{ column.label }}
                <button @click="sortByDetail(column.key)" class="text-xs text-gray-500">
                  <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </span>
                </button>
              </div>
            </template>
            <template #header-modified-detail="{ column }">
              <div class="flex items-center gap-1">
                {{ column.label }}
                <button @click="sortByDetail(column.key)" class="text-xs text-gray-500">
                  <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </span>
                </button>
              </div>
            </template>

            <template #created="{ value }">
              <span>{{ formatDate(value).date }}</span>
              <br>
              <span class="italic text-xs">{{ formatDate(value).time }}</span>
            </template>
            <template #is_active="{ value }">
              <span class="px-2 py-1 rounded-lg text-xs font-medium capitalize" :class="statusColor(value)">
                {{ value ? 'Active' : 'Inactive' }}
              </span>
            </template>
            <template #modified="{ value }">
              <span>{{ formatDate(value).date }}</span>
              <br>
              <span class="italic text-xs">{{ formatDate(value).time }}</span>
            </template>
          </Table>
          <div v-if="fetchPublisherID?.length"
            class="flex bg-white justify-between pl-3 pr-3 pt-3 border-t mb-0 border-gray-100">
            <div class="font-semibold">
              <span class="text-gray-500 font-normal">Showing </span> {{ currentPageDetailPublisher }}-{{
                perPageDetailPublisher }} <span class="text-gray-500 font-normal">of</span> {{
                parseInt(totalRowsDetailPubsher) }}
            </div>
            <div class="mb-2">
              <t-pagination @change="handlePageClickDetail" :total-items="Number(totalRowsDetailPubsher)"
                :per-page="perPageDetailPublisher" v-model="currentPageDetailPublisher" />
            </div>
          </div>
        </div>
      </div>
    </t-modal-table>
  </div>

</template>

<script>
import { mapState, mapActions } from "vuex";
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Table from '@/components/form/table.vue'
import { PublisherGroup } from "../../router/clients";
import { EventBus } from '../../../src/event-bus'
import moment from 'moment';

export default {
  name: "PublisherGroup",
  components: {
    HeaderBreadcrumbs,
    Table,
  },
  data() {
    return {
      currentPage: 1,
      currentPageDetailPublisher: 1,
      perPageDetailPublisher: 10,
      perPage: 15,
      sorts: [],
      sortString: [],
      search: '',
      publisherId: '',
      deleteId:null,
      debounce: null,
      typing: false,
      totalRowsDetailPubsher: null,
      fetchPublisherID: [],
      headers: [
        { label: 'No', key: 'no' },
        { label: 'Publisher Group Name', key: 'name' },
        { label: 'Publisher', key: 'id' },
        { label: 'Created Date', key: 'created', sortable: true, slotHeader: 'header-joinDate' },
        { label: 'Last Modified', key: 'modified', sortable: true, slotHeader: 'header-modified' },

      ],
      headersDetailId: [
        { label: 'No', key: 'no', class: "bg-red-200" },
        { label: 'Publisher Name', key: 'name' },
        { label: 'Status', key: 'is_active' },
        { label: 'Created Date', key: 'created', sortable: true, slotHeader: 'header-joinDate-detail' },
        { label: 'Last Modified', key: 'modified', sortable: true, slotHeader: 'header-modified-detail' },
      ],
      PublisherGroup,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.vendors.isLoading,
      isError: (state) => state.vendors.isError,
      totalRows: (state) => state.vendors.totalRows,
      items: (state) => state.vendors.items,
    }),
  },

  mounted() {

    this.actionGetPublisherGroup();
  },
  methods: {
    ...mapActions('vendors', [
      'fetchPublisherGroup', 'fetchPublisherGroupById', 'deletePublisherGroup'
    ]),
    actionGetPublisherGroup() {
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
        is_active: true,
      };
      if (this.search) payload.name = this.search;
      this.fetchPublisherGroup(payload);

    },
    actionReset() {
      this.search = ''
      this.actionGetPublisherGroup();
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss')
      };
    },
    statusColor(status) {
      switch (status) {
        case true:
          return 'bg-green-100 text-green-700';
        case false:
          return 'bg-gray-200 text-gray-800';
      }
    },
    onSearch(q) {
      const search = q.target.value;
      this.search = search;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = false;
        let payload = {
          page: this.currentPage = 1,
          limit: this.perPage,
          is_active: true,
        };
        if (this.search) payload.name = this.search;
        this.fetchPublisherGroup(payload);
      }, 600);
    },
    toggleSort(column) {
    const existing = this.sorts.findIndex(s => s.column === column);

    if (existing >= 0) {
      this.sorts[existing].order = this.sorts[existing].order === 'asc' ? 'desc' : 'asc';
      const [item] = this.sorts.splice(existing, 1);
      this.sorts.unshift(item);
    } else {
      this.sorts.unshift({ column, order: 'asc' });
    }
    this.sortString = this.sorts.map(s => `${s.column}_${s.order}`).join(',');
  
  },


    sortBy(column) {
     this.toggleSort(column)

      let data = {
        sort: this.sortString,
        page: this.currentPage,
        limit: this.perPage,
        is_active: true,
      };
      this.fetchPublisherGroup(data);
    },

    async sortByDetail(column) {
     this.toggleSort(column)
      
     const data = {
        sort: this.sortString,
        page: this.currentPageDetailPublisher,
        limit: this.perPageDetailPublisher,
        id: this.publisherId,
      };

      try {
        const response = await this.fetchPublisherGroupById(data);
        this.fetchPublisherID = response.vendors || [];
        this.totalRowsDetailPubsher = response.count || 0;
      } catch (error) {
        console.error("Failed to sort publisher detail:", error);
      }
    },


    async loadPublisherDetail(page = this.currentPageDetailPublisher) {
      const payload = {
        id: this.publisherId,
        page,
        limit: this.perPageDetailPublisher,

      };

      try {
        const response = await this.fetchPublisherGroupById(payload);
        this.fetchPublisherID = response.vendors || [];
        this.totalRowsDetailPubsher = response.count || 0;
      } catch (error) {
        console.error("Failed to load publisher detail:", error);
      }
    },
    closeX() {
      this.$refs.showtabel.hide();
    },
    async handlePageClickDetail(page) {
      this.currentPageDetailPublisher = page;
      await this.loadPublisherDetail(page);
    },
    handlePageClicklist(page) {
    let payload = {
            page: page,
            limit: this.perPage,
            is_active: true,
          };
      if (this.search) payload.name = this.search;
      this.fetchPublisherGroup(payload);
    },
    showPopup(id) {
    this.deleteId = id
    this.$refs.modalActionDelete.show();
    },
    onCancel() {
        this.$refs.modalActionDelete.hide();
    },
    async onDeletePublisher() {
      await this.deletePublisherGroup(this.deleteId).then(response => {
        if (response) {
          EventBus.$emit('show-toast', {
            message: 'Publisher group has been deleted.',
            type: 'success',
          });
          this.$refs.modalActionDelete.hide();
          this.actionGetPublisherGroup();
        }
      })

    },
    async showModal(id) {
      this.publisherId = id;
      this.currentPageDetailPublisher = 1
      try {
        await this.loadPublisherDetail(this.currentPageDetailPublisher);
        this.$refs.showtabel.show();
      } catch (err) {
        console.log(err)
      }
    }
  }
};
</script>

<style>
.custom-table table tbody td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.custom-table-parent table tbody td {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
</style>